/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import PropTypes from "prop-types";
import Article from "../../../entities/article";
import Label from "./components/Labels";
import ArticleBoxThumbnail from "../../ArticleBoxThumbnail";

function PCArticleBox({ article }) {
  const imageUrl = article.medium_pic_url;
  const userIconUrl = article.user?.icon_url;
  const showingUserIconFallback =
    !article.medium_pic_url && article.user?.icon_url;

  return (
    <article
      className={`resultBox jsResultBox isWideInside jsArticle${
        article.id
      } gtmEventArticleAlgorithm ${
        article.is_closing() ? "jsClosingArticle" : ""
      }`}
      // NOTE: 動的にプロパティが生成されているので、eslintのチェックを無効化
      // eslint-disable-next-line react/prop-types, react/jsx-props-no-spreading
      {...article.gtm_article_data()}
      // eslint-disable-next-line react/prop-types, react/jsx-props-no-spreading
      {...(article.gtm_ecommerce_data_attributes?.() ?? {})}
    >
      <div className="infoBox">
        <a href={article.path()}>
          <div className="resultBoxContainer">
            <div className="resultBoxInline">
              <div
                className={`resultBoxTop ${
                  showingUserIconFallback ? "showingUserIcon" : ""
                }`}
              >
                <ArticleBoxThumbnail
                  imageUrl={imageUrl}
                  userIconUrl={userIconUrl}
                  effect="opacity"
                  showUserIconBackground={false}
                />
              </div>
              <div className="resultBoxBottom">
                <div>
                  <Label key={article.id} article={article} />
                </div>
                <h3 className="articleTitle">{article.title}</h3>
                <div className="isUserName">{article.user_name()}</div>
                <ul className="resultElements">
                  {Article.category_labels().map(
                    (cat) =>
                      article[cat] && (
                        <li key={cat}>
                          <div
                            key={cat}
                            className={`p_icon ${Article.class_name(
                              cat
                            )} resultElementsItem`}
                          />
                          <div
                            className="itemText"
                            dangerouslySetInnerHTML={{
                              __html: article.category_names(cat),
                            }}
                          />
                        </li>
                      )
                  )}
                </ul>
              </div>
            </div>
            <div className="resultBoxInlineDesc">
              {article.description && (
                <p className="js2LinesLimitBottom resultDesc">
                  {article.description}
                </p>
              )}
              <ul className="articleTags">
                {article.tag_names_for_ab().length != 0 &&
                  article.tag_names_for_ab().map((name: string) => (
                    <li className="tagName" key={`tagname-${name}`}>
                      {name}
                    </li>
                  ))}
              </ul>
            </div>
            <div className="resultLinkBotton">
              <div
                className="p_bookmarkIconBtn jsBookmark"
                data-id={`${article.id}`}
              >
                <button
                  type="button"
                  className="bookmarkAdd"
                  data-remote="true"
                  data-method="post"
                  data-url={article.bookmark_path("post")}
                />
                <button
                  type="button"
                  className="bookmarkRemove"
                  data-remote="true"
                  data-method="delete"
                  data-url={article.bookmark_path("delete")}
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    </article>
  );
}

PCArticleBox.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    is_closing: PropTypes.func,
    gtm_article_data: PropTypes.func,
    gtm_ecommerce_data_attributes: PropTypes.func,
    path: PropTypes.func,
    medium_pic_url: PropTypes.string,
    main_pic_url: PropTypes.string,
    title: PropTypes.string,
    user_name: PropTypes.func,
    category_labels: PropTypes.func,
    category_names: PropTypes.func,
    description: PropTypes.string,
    bookmark_path: PropTypes.func,
    tag_names_for_ab: PropTypes.func,
    user: PropTypes.shape({
      icon_url: PropTypes.string,
    }),
  }),
};

PCArticleBox.defaultProps = {
  article: {
    id: null,
    is_closing: () => {},
    gtm_article_data: () => {},
    gtm_ecommerce_data_attributes: () => {},
    path: () => {},
    medium_pic_url: "",
    main_pic_url: "",
    title: "",
    user_name: () => {},
    category_labels: () => {},
    category_names: () => {},
    description: "",
    bookmark_path: () => {},
    tag_names_for_ab: () => [],
    user: {
      icon_url: "",
    },
  },
};

export default PCArticleBox;
